export { default } from "./ImmersiveAgilityFactorChart";
